import { UseBoundStore } from 'zustand';

export const allStores: UseBoundStore<any>[] = [];
